module.exports = __webpack_public_path__ + "img/C04TechImmortal2_ua.8884c82f.webp";